import { connect } from 'react-redux';
import * as resumeActions from 'redux-modules/resume/actions.js';
import * as resumeSelectors from 'redux-modules/resume/selectors.js';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';
import MyNotificationSettings from './MyNotificationSettings';

function mapStateToProps(state) {
  return {
    language: uiStateSelectors.selectLanguageCode(state),
    loading: resumeSelectors.selectLoadState(state),
    notificationSettings: resumeSelectors.selectNotificationSettings(state),
    syncErrors: resumeSelectors.selectSyncError(state),
    syncing: resumeSelectors.selectSyncState(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSave: (data, failCallback) => dispatch(resumeActions.saveNotificationSettings(data, failCallback))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MyNotificationSettings);
